import { X } from "lucide-react";
import clsx from "clsx";
import { useDock } from "../chat/dock";
import { ComposeWindow } from "./ComposeWindow";
import { dismissToast, useComposers, useToasts } from "./composeData";
import s from "./Compose.module.css";

/** Docked compose windows (left of any chat windows) on desktop; one full-screen sheet on phones. */
export function ComposeDock({ isPhone }: { isPhone: boolean }) {
  const composers = useComposers().filter((c) => !c.inlineThread);
  const chat = useDock();
  if (!composers.length) return null;
  if (isPhone) {
    const top = composers[composers.length - 1]!;
    return <ComposeWindow key={top.draftId} draftId={top.draftId} variant="sheet" />;
  }
  const right = 16 + chat.windows.length * (340 + 12);
  return (
    <div className={s.dockRow} style={{ right }}>
      {composers.map((c) => (
        <ComposeWindow key={c.draftId} draftId={c.draftId} variant="dock" minimized={c.minimized} maximized={c.maximized} />
      ))}
    </div>
  );
}

export function Toaster() {
  const toasts = useToasts();
  return (
    <div className={s.toasts} aria-live="polite" aria-atomic="false">
      {toasts.map((t) => (
        <div key={t.id} className={clsx(s.toast, t.tone === "error" && s.toastError)} role={t.tone === "error" ? "alert" : "status"}>
          <span className={s.toastText}>{t.text}</span>
          {t.action && (
            <button type="button" className={s.toastAction} onClick={() => { dismissToast(t.id); t.action!.run(); }}>
              {t.action.label}
            </button>
          )}
          <button type="button" className={s.toastClose} aria-label="Dismiss" onClick={() => dismissToast(t.id)}>
            <X />
          </button>
        </div>
      ))}
    </div>
  );
}
